import { validatenum } from './validate';
import { Lang } from '../lang/lang';

export const validatePass = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(Lang.tips.inputPassword));
  } else {
    callback();
  }
};
export const validatePasswordStr = (password) => {
  // 正则表达式解释：
  // ^ 表示字符串开始
  // (?=.*[a-z]) 至少包含一个小写字母
  // (?=.*[A-Z]) 至少包含一个大写字母
  // (?=.*\d) 至少包含一个数字
  // (?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]) 至少包含一个特殊字符
  // [a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,18} 允许的字符范围，长度6-18
  // $ 表示字符串结束
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,18}$/;
  return regex.test(password);
}
export const validatePasswordSimple = (password) => {
  // 允许大小写字母、数字和常见符号，长度6-18
  const regex = /^[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,18}$/;
  return regex.test(password);
}
export const validatePassword = (rule, value, callback) => {
  // 允许大小写字母、数字和常见符号，长度6-18
  const regex = /^[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,18}$/;
  if (!value) {
    callback(new Error(Lang.Text.userOrgPassLength));
  } else if (!regex.test(value)) {
    callback(new Error(Lang.Text.userOrgPassLength));
  } else {
    if (value.length < 6 || value.length > 18) {
      callback(new Error(Lang.Text.userOrgPassLength));
    } else {
      callback();
    }
  }
}
export const validateMax10DigtsWith3Point = (rule, value, callback) => {
  if (!value) {
    if (value === 0) {
      callback(new Error(Lang.tips.maxLength10Digits3points));
    } else {
      callback(); // 如果值为空，不进行校验
    }
  } else if (!/^\d{1,7}(\.\d{1,3})?$/.test(value)) {
    callback(new Error(Lang.tips.maxLength10Digits3points));
  } else {
    callback();
  }
}
export const validateMax10DigtsWithPoint = (rule, value, callback) => {
  if (!value) {
    callback(); // 如果值为空，不进行校验
  } else if (!/^\d{1,7}(\.\d{1,6})?$/.test(value)) {
    callback(new Error(Lang.tips.maxLength10Digits));
  } else {
    callback();
  }
}

export const validateMax5DigtsWithPoint = (rule, value, callback) => {
  if (!value) {
    callback(); // 如果值为空，不进行校验
  } else if (!/^\d{1,5}(\.\d{1,4})?$/.test(value)) {
    callback(new Error(Lang.tips.maxLength5Digits));
  } else {
    callback();
  }
}

export const validateMax10Digits = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!/^\d{1,10}$/.test(value)) {
    callback(new Error(Lang.tips.maxLength10Digits)); // 提示信息：最多10位数字
  } else {
    callback();
  }
};
export const validateMax7Digits = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!/^\d{1,7}$/.test(value)) {
    callback(new Error(Lang.tips.maxLength7Digits)); // 提示信息：最多10位数字
  } else {
    callback();
  }
};
export const validateUserCode = (rule, value, callback) => {
  // 允许大小写字母、数字，长度6-18
  const regex = /^[A-Za-z0-9]{2,18}$/;
  if (!value) {
    callback();
  } else if (!regex.test(value)) {
    callback(new Error(Lang.tips.validateUserCode));
  } else {
    if (value.length < 1 || value.length > 30) {
      callback(new Error(Lang.tips.validateUserCode));
    } else {
      callback();
    }
  }
}
export const validateUerName = (rule, value, callback) => {
  // 允许大小写字母、数字，长度6-18
  // const regex = /^[A-Za-z0-9]{6,18}$/;
  // if (!value) {
  //   callback(new Error('User code length should be between 1 to 30 characters'));
  // } else if (!regex.test(value)) {
  //   callback(new Error('User code length should be between 1 to 30 characters'));
  // } else {
  //   if (value.length < 1 || value.length > 30) {
  //     callback(new Error('User code length should be between 1 to 30 characters'));
  //   } else {
  //     callback();
  //   }
  // }
}


export const validatePass2 = (rule, value, callback) => {
  if (value === '') {
    callback(new Error(Lang.tips.plzInputPasswordAgain));
  } else if (value !== this.form.password) {
    callback(new Error(Lang.tips.twoPasswordWasDiffrent));
  } else {
    callback();
  }
};

export const validateInt = (rule, value, callback) => {
  if (!value) {
    callback();
  } else if (!/^[0-9]+$/.test(value)) {
    callback(new Error(Lang.tips.limit0Int));
  } else {
    callback();
  }
};


export const validateDeviceId = (rule, value, callback) => {
  if (!/^[^\u4e00-\u9fa5]+$/.test(value)) { // 除中文之外的字符
    callback(new Error(Lang.tips.plzInputChartOrNumber));
  } else {
    if (value.length > 50) {
      callback(new Error(Lang.tips.deviceIdLengthLimit50));
    } else {
      callback();
    }
  }
};



export const validateTimeout = (rule, value, callback) => {
  if (!value && value !== 0) {
    callback();
  }
  if (value < 1) {
    callback(new Error(Lang.tips.timeoutMustBiggerThen1));
  }
  if (!/^\d+$/.test(value)) {
    callback(new Error(Lang.tips.plzInputIntNumber));
  } else {
    callback();
  }
}
export const validateGatewayId = (rule, value, callback) => {
  if (!value) {
    callback();
  }
  if (!/^[A-Za-z0-9]+$/.test(value)) {
    callback(new Error(Lang.tips.plzInputChartOrNumber));
  } else {
    if (value.length < 1 || value.length > 50) {
      callback(new Error(Lang.tips.assetsIdLengthLimit1To50));
    } else {
      callback();
    }
  }
};

export const validateOrgCode = (rule, value, callback) => {
  if (!value) {
    callback();
  }
  if (!/^[A-Za-z0-9]+$/.test(value)) {
    callback(new Error(Lang.tips.plzInputChartOrNumber));
  } else {
    if (value.length > 30) {
      callback(new Error(Lang.tips.deviceIdLengthLimit20));
    } else {
      callback();
    }
  }
};

export const validateAssetId = (rule, value, callback) => {
  if (!value) {
    callback();
  }
  if (!/^[A-Za-z0-9]+$/.test(value)) {
    callback(new Error(Lang.tips.plzInputChartOrNumber));
  } else {
    if (value.length < 8 || value.length > 50) {
      callback(new Error(Lang.tips.assetsIdLengthLimit8To50));
    } else {
      callback();
    }
  }
};


export const validateWord = (rule, value, callback) => {
  if (!/^[A-Za-z]+$/.test(value)) {
    callback(new Error(Lang.tips.plzInputEnCharater));
  } else {
    callback();
  }
};

export const validateConfirmPassword = (rule, value, callback, formData) => {
  if (value === '') {
    callback(new Error(Lang.Toast.userInfoPassNotMatch));
  } else if (value !== formData.newPassword) {
    callback(new Error(Lang.Toast.userInfoPassNotMatch));
  } else {
    callback();
  }
};

/**
 * 验证纬度值
 * @param {string|number} value - 要验证的纬度值
 * @returns {boolean} - 是否有效
 */
export const isValidLatitude = (rule, value, callback) => {
  if (!value) {
    callback();
    return
  }
  // 转换为字符串处理
  const strValue = String(value).trim();
  // 检查是否为有效数字
  if (!/^-?\d+(\.\d{1,6})?$/.test(strValue)) {
    return callback(new Error(Lang.tips.plzInputValidateLatitude));
  }
  // 转换为数字
  const numValue = parseFloat(strValue);
  // 检查范围
  if (numValue < -90 || numValue > 90) {
    return callback(new Error(Lang.tips.plzInputValidateLatitude));
  }
  // 检查小数位数
  const decimalParts = strValue.split('.');
  if (decimalParts.length === 2 && decimalParts[1].length > 6) {
    return callback(new Error(Lang.tips.plzInputValidateLatitude));
  }
  callback();
}

/**
* 验证经度值
* @param {string|number} value - 要验证的经度值
* @returns {boolean} - 是否有效
*/
export const isValidLongitude = (rule, value, callback) => {
  // 转换为字符串处理
  if (!value) {
    callback();
    return
  }
  const strValue = String(value).trim();
  // 检查是否为有效数字
  if (!/^-?\d+(\.\d{1,6})?$/.test(strValue)) {
    return callback(new Error(Lang.tips.plzInputValidateLongitude));
  }
  // 转换为数字
  const numValue = parseFloat(strValue);
  // 检查范围
  if (numValue < -180 || numValue > 180) {
    return callback(new Error(Lang.tips.plzInputValidateLongitude));
  }
  // 检查小数位数
  const decimalParts = strValue.split('.');
  if (decimalParts.length === 2 && decimalParts[1].length > 6) {
    return callback(new Error(Lang.tips.plzInputValidateLongitude));
  }
  callback();
}

/** 
 * 验证电子邮件地址
 * @param {string} email - 要验证的电子邮件地址
 */
export const validateEmail = (rule, value, callback) => {
  if (!value) {
    callback();
  } else {
    const reg = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    if (!reg.test(value)) {
      callback(new Error(Lang.tips.plzInputValidateEmail));
    } else {
      callback();
    }
  }
}

export const validateInput = (rule, value, callback, options) =>  {
  const defaults = {
    min: 0.01,
    max: 100,
    allowEmpty: false,
    decimalPlaces: 2 // 允许的小数位数
  };
  const settings = {...defaults, ...options};
  // 处理空值
  if (value === '' || value === null || value === undefined) {
    return callback(new Error(Lang.label.energyFlowWrongLossNo));
  }
  // 转换为数字
  const num = parseFloat(value);
  // 检查是否为有效数字
  if (isNaN(num)) {
    return callback(new Error(Lang.label.energyFlowWrongLossNo));
  }
  // 检查范围
  if (num < settings.min || num > settings.max) {
    return callback(new Error(Lang.label.energyFlowWrongLossNo));
  }
  // 检查小数位数
  if (settings.decimalPlaces !== undefined) {
    const decimalPart = value.toString().split('.')[1];
    if (decimalPart && decimalPart.length > settings.decimalPlaces) {
      return callback(new Error(Lang.label.energyFlowWrongLossNo));
    }
  }
  return callback();
}